import { LDProvider, useLDClient } from 'launchdarkly-react-client-sdk'

import useFlags from './hooks/use-flags.ts'

export { LDProvider as FlagsProvider, useFlags, useLDClient as useFlagsClient }
